// Screenname:DeliveryTerms master
// Developer Name: Jagadish.
// Created date on: 2 / 2 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages: 
import httpbaseURL from '../common/axios';
class DeliveryTermsservices {
    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/DeliveryTermsMAS/Create", doc)
    }
    getdata() {
        return httpbaseURL.httpMSInventoryUrl.get("/DeliveryTermsMAS/List")
    }
    getfindonedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.get("/DeliveryTermsMAS/Get?id=" + doc)
    }

    updatedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/DeliveryTermsMAS/Update", doc)
    }
    deletedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.delete("/DeliveryTermsMAS/Delete?id=" + doc)
    }
    active(DelID, Status) {
        debugger;
        return httpbaseURL.httpMSInventoryUrl.put(
            "DeliveryTermsMAS/Active?id=" + DelID + "&Status=" + Status + ""
        );
    }
}
export default new DeliveryTermsservices()